import { render } from "./Advisors.vue?vue&type=template&id=599d2ffe"
import script from "./Advisors.vue?vue&type=script&lang=js"
export * from "./Advisors.vue?vue&type=script&lang=js"
script.render = render

export default script